var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.textClass,staticStyle:{"margin-bottom":"0","font-size":"1.5em"},domProps:{"textContent":_vm._s(_vm.message)}})}
var staticRenderFns = []

export { render, staticRenderFns }